import { service } from "@ember/service";
import EmberRouter from "@ember/routing/router";
import config from "glesys-controlpanel/config/environment";
import { macroCondition, getOwnConfig } from "@embroider/macros";

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;

  @service router;

  constructor() {
    super(...arguments);

    this.handleRedirectFromHashToHistory();
  }

  handleRedirectFromHashToHistory() {
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.href.replace("#/", ""));
    }
  }
}

const resetNamespace = true;

Router.map(function () {
  this.route("login");
  this.route("signup");
  this.route("recover", function () {
    this.route("request", { path: "/" });
    this.route("confirm", { path: "/:token" });
  });

  this.route("confirm", { path: "confirm/:token" });

  this.route("dashboard", { path: "/" }, function () {
    this.route("home", { path: "/" });

    this.route("api-access");

    this.route("support-challenge");

    this.route("invites");

    this.route("organizations", { resetNamespace }, function () {
      this.route("create");
    });

    this.route("settings");

    this.route("invite", { path: "invite/:invite_code" });

    this.route("organization", { path: "/:organization_id", resetNamespace }, function () {
      this.route("not-found", { path: "*path", resetNamespace });

      this.route("overview", { path: "/" }, function () {
        this.route("dashboard", { path: "/" });
        this.route("networks", { resetNamespace });

        this.route("servers", { resetNamespace }, function () {
          this.route("overview", { path: "/" });

          this.route("create", function () {
            this.route("virtual", { path: "/" });
            this.route("dedicated");
            this.route("from-backup");
          });
          this.route("appliance", { path: "/create/appliance" }, function () {
            this.route("overview", { path: "/" });
            this.route("creating", { path: "/creating/:server_id/type/:type" });

            this.route("jitsi");
            this.route("wordpress");
            this.route("gitlab");
            this.route("plesk");
          });

          this.route("clone", { path: "/clone/:server_id" });

          this.route("server", { path: "/:server_id", resetNamespace }, function () {
            this.route("details", { path: "/" });

            this.route("disks");
            this.route("backup");
            this.route("iso");
            this.route("network-adapters");
            this.route("statistics");
            this.route("volumes");
          });
        });

        this.route("ips", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
          this.route("reserve");
          this.route("cost");
        });

        this.route("load-balancers", { resetNamespace }, function () {
          this.route("overview", { path: "/" });

          this.route("load-balancer", { path: "/:load_balancer_id", resetNamespace }, function () {
            this.route("details", { path: "/" });

            this.route("advanced");
            this.route("errors");
            this.route("statistics");
          });
        });

        this.route("databases", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
          this.route("details", { path: "/:database_id" }, function () {
            this.route("overview", { path: "/" });
            this.route("databases-and-users");
          });

          this.route("create");
        });

        this.route("dns", { resetNamespace }, function () {
          this.route("overview", { path: "/" });

          this.route("register");

          this.route("domain", { path: "/:dns_domain_id" }, function () {
            this.route("dns-records", { path: "/" });
            this.route("dnssec");
          });
        });

        this.route("email", { resetNamespace }, function () {
          this.route("overview", { path: "/" });

          this.route("domain", { path: "/:email_domain_id" }, function () {
            this.route("details", { path: "/" });

            this.route("account", { path: "/:email_account_id" });
          });
        });

        this.route("file-storage-volumes", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
          this.route("create");
          this.route("details", { path: "/:file_storage_volume_id" });
        });

        this.route("block-storage", { resetNamespace }, function () {
          this.route("volumes", { path: "/" }, function () {
            this.route("overview", { path: "/" });
            this.route("create");
            this.route("details", { path: "/:block_storage_volume_id" });
          });
        });

        this.route("private-networks", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
          this.route("details", { path: "/:private_network_id" });
        });

        this.route("network-circuits", { resetNamespace });

        this.route("archives", { resetNamespace }, function () {
          this.route("overview", { path: "/" });

          this.route("archive", { path: "/:archive_id", resetNamespace });
        });

        this.route("vpn", { resetNamespace });

        this.route("ssh-keys", { resetNamespace });

        this.route("object-storage", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
          this.route("details", { path: "/:object_storage_id" });
        });

        this.route("colocation-racks", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
        });

        this.route("shipments", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
        });

        this.route("remote-hands-request", { resetNamespace }, function () {
          this.route("overview", { path: "/" });
          this.route("create");
          this.route("details", { path: "/:remote_hands_request_id" });
        });
      });
      this.route("add-payment-method");
      this.route("settings");
      this.route("invoices", function () {
        this.route("overview", { path: "/" });
        this.route("next-invoice");
      });
      this.route("remote-hands");

      this.route("projects", { resetNamespace }, function () {
        this.route("create");
      });

      this.route("collaborators", function () {
        this.route("overview", { path: "/" });
        this.route("details", { path: ":collaborator_id" });
      });
    });
  });

  if (macroCondition(getOwnConfig().designSystem)) {
    this.route("design-system", function () {
      this.route("overview", { path: "/" });

      this.route("tokens", function () {
        this.route("overview", { path: "/" });
        this.route("colors");
        this.route("typography");
        this.route("spacing");
      });

      this.route("primitives", function () {
        this.route("overview", { path: "/" });
        this.route("component", { path: "/:component_id" });
      });

      this.route("patterns", function () {
        this.route("overview", { path: "/" });
        this.route("component", { path: "/:component_id" });
      });

      this.route("layouts", function () {
        this.route("overview", { path: "/" });
        this.route("component", { path: "/:component_id" });
      });

      this.route("behaviors", function () {
        this.route("overview", { path: "/" });
        this.route("component", { path: "/:component_id" });
      });

      this.route("guidelines", function () {
        this.route("overview", { path: "/" });
        this.route("doc", { path: "/:doc_id" });
      });
    });
  }
});
